import {DeliveryStatus} from "../../constants/DeliveryStatus";
import {Moment} from "moment";
import {DeliveryProgress} from "../../app/components/DeliveryProgressBar";
import {FirebaseService} from "../firebase/FirebaseService";
import {HelpTypes} from "../../app/components/NeedHelpPopUp";
import {NotPresentAction} from "../../app/components/NotTherePopUp";

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * Service class that contains method for update operations
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 * @constructor
 */
export class UpdateAtDatabaseService {
  /**
   * Updates the changeable data of a delivery
   *
   * @param trackingID
   * @param selectedStatus
   * @param chosenETA
   * @param deliveryProgress
   */
  public static async updateDelivery(
    trackingID: string,
    selectedStatus: DeliveryStatus,
    chosenETA: Moment,
    deliveryProgress: DeliveryProgress
  ) {
    await FirebaseService.dbRef()
      .deliveries()
      .child(trackingID)
      .update({
        estimatedTimeOfArrival: chosenETA && chosenETA.toISOString(),
        status: selectedStatus,
        deliveryProgress: deliveryProgress,
      });
  }

  /**
   * Updates the delivery Action that the receiver is there
   *
   * @param trackingID
   */
  public static async updateNotThereAction(trackingID: string) {
    await FirebaseService.dbRef().deliveries().child(trackingID).update({
      isPresent: true,
    });
  }

  /**
   * Updates the delivery Action that the receiver does not need help
   *
   * @param trackingID
   */
  public static async updateNoHelpNeeded(trackingID: string) {
    await FirebaseService.dbRef().deliveries().child(trackingID).update({
      noHelpNeeded: true,
    });
  }

  /**
   * Updates the delivery Action that the receiver does not need help
   *
   * @param trackingID
   * @param selectedHelp
   */
  public static async updateHelpIsNeeded(
    trackingID: string,
    selectedHelp: HelpTypes
  ) {
    await FirebaseService.dbRef().deliveries().child(trackingID).update({
      bookedHelp: selectedHelp,
      noHelpNeeded: false,
    });
  }

  /**
   * Updates the signature release as the chosen not there option
   *
   * @param trackingID
   */
  public static async updateNotThereOption(trackingID: string) {
    await FirebaseService.dbRef().deliveries().child(trackingID).update({
      chosenNotPresentOption: NotPresentAction.SIGNATURE_RELEASE_AUTHORISATION,
    });
  }

  /**
   * Updates the delivery that it is declined
   *
   * @param trackingID
   */
  public static async updateDeclineDelivery(trackingID: string) {
    await FirebaseService.dbRef().deliveries().child(trackingID).update({
      status: DeliveryStatus.canceled,
      chosenNotPresentOption: NotPresentAction.DECLINE,
    });
  }

  /**
   * Updates the delivery that it is dropped at the Neighbours
   *
   * @param trackingID
   */
  public static async updateNeighbourRelease(trackingID: string) {
      await FirebaseService.dbRef().deliveries().child(trackingID).update({
          chosenNotPresentOption: NotPresentAction.NEIGHBOR_RELEASE,
      });
  }
}
